import API from 'api/hallomart';

/**
 * Constants
 */

export const FETCH_OUTLET_DETAILS = 'outlet/FETCH_OUTLET_DETAILS';
export const FETCH_OUTLET_DETAILS_OK = 'outlet/FETCH_OUTLET_DETAILS_OK';
export const FETCH_OUTLET_DETAILS_FAILED = 'outlet/FETCH_OUTLET_DETAILS_FAILED';

/**
 * Actions
 */

export function fetchBranchDetails(id) {
  return async (dispatch) => {
    dispatch({ type: FETCH_OUTLET_DETAILS });

    try {
      const branch = await API.getMerchantBranchDetails(id);
      dispatch({
        type: FETCH_OUTLET_DETAILS_OK,
        payload: branch.data,
      });
    } catch (err) {
      dispatch({ type: FETCH_OUTLET_DETAILS_FAILED, error: err.response || err.message });
    }
  };
}

/**
 * Reducers
 */

const initialState = {
  isLoading: false,
  isLoaded: false,
  error: false,
  errors: {},
  data: {},
};

export default function outletDetails(state = initialState, action) {
  switch (action.type) {
    case FETCH_OUTLET_DETAILS:
      return {
        ...state,
        error: false,
        errors: {},
        isLoading: true,
        isLoaded: false,
      };

    case FETCH_OUTLET_DETAILS_OK:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        data: action.payload,
      };

    case FETCH_OUTLET_DETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        error: true,
        errors: action.error,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/outletDetails.js